import React, { useState } from 'react';
import './Products.css';
import './AllSellStyles.css';
import './CommonStyles.css';
import { exportToCSV, exportToExcel, exportToPDF, printPage } from './exportUtils';

const ProfitLossReport = () => {
    const [activeSubTab, setActiveSubTab] = useState('products');
    const [entriesPerPage, setEntriesPerPage] = useState(25);
    const [searchTerm, setSearchTerm] = useState('');
    const [showExportDropdown, setShowExportDropdown] = useState(false);

    const subTabs = [
        { id: 'products',   label: 'Profit by products',   icon: 'fa-cube' },
        { id: 'categories', label: 'Profit by categories', icon: 'fa-tags' },
        { id: 'brands',     label: 'Profit by brands',     icon: 'fa-th-large' },
        { id: 'locations',  label: 'Profit by locations',  icon: 'fa-map-marker' },
        { id: 'invoice',    label: 'Profit by invoice',    icon: 'fa-file-text-o' },
        { id: 'date',       label: 'Profit by date',       icon: 'fa-calendar' },
        { id: 'customer',   label: 'Profit by customer',   icon: 'fa-user' },
        { id: 'day',        label: 'Profit by day',        icon: 'fa-calendar-o' },
    ];

    const handleExport = (format) => {
        const headers = ['Product', 'Gross Profit'];
        const rows = []; // Mock data for now since table is empty

        const title = `Profit Loss Report - ${activeSubTab}`;
        const filename = `profit_loss_${activeSubTab}`;

        if (format === 'CSV') exportToCSV(headers, rows, filename);
        else if (format === 'Excel') exportToExcel(headers, rows, filename);
        else if (format === 'PDF') exportToPDF(title, headers, rows, filename);
        else if (format === 'Print') printPage();
    };

    const exportItems = [
        { icon: 'fa-file-excel-o', label: 'Export CSV', action: () => handleExport('CSV') },
        { icon: 'fa-file-excel-o', label: 'Export Excel', action: () => handleExport('Excel') },
        { icon: 'fa-print',        label: 'Print', action: () => handleExport('Print') },
        { icon: 'fa-table',        label: 'Column visibility' },
        { icon: 'fa-file-pdf-o',   label: 'Export PDF', action: () => handleExport('PDF') },
    ];

    return (
        <div style={{ paddingTop: '0.5rem' }}>

            {/* ── Two-column Metrics Grid ── */}
            <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '1rem',
                marginBottom: '1rem',
            }}>
                {/* Left Card */}
                <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '1.25rem 1.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
                    {[
                        { label: 'Opening Stock (By purchase price):',  value: '$ 2,668,126.14' },
                        { label: 'Opening Stock (By sale price):',       value: '$ 3,446,908.87' },
                        { label: 'Total purchase: (Exc. tax, Discount)', value: '$ 2,048.63',  hi: true },
                        { label: 'Total Stock Adjustment:',              value: '$ 0.00' },
                        { label: 'Total Expense:',                       value: '$ 0.00',  hi: true },
                        { label: 'Total purchase shipping charge:',      value: '$ 0.00' },
                        { label: 'Purchase additional expenses:',        value: '$ 0.00',  hi: true },
                        { label: 'Total transfer shipping charge:',      value: '$ 0.00' },
                        { label: 'Total Sell discount:',                 value: '$ 950.00', hi: true },
                        { label: 'Total customer reward:',               value: '$ 0.00' },
                        { label: 'Total Sell Return:',                   value: '$ 0.00',  hi: true },
                        { label: 'Total Payroll:',                       value: '$ 0.00' },
                        { label: 'Total Production Cost:',               value: '$ 0.00',  hi: true },
                    ].map((row, i) => (
                        <div key={i} style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            padding: '0.5rem 0.5rem',
                            background: row.hi ? '#f8fafc' : 'transparent',
                            borderBottom: '1px solid #f1f5f9',
                        }}>
                            <span style={{ fontSize: '0.8125rem', color: '#334155', fontWeight: '500' }}>{row.label}</span>
                            <span style={{ fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600' }}>{row.value}</span>
                        </div>
                    ))}
                </div>

                {/* Right Card */}
                <div style={{ background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '1.25rem 1.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
                    {[
                        { label: 'Closing stock (By purchase price):',  value: '$ 2,669,050.68' },
                        { label: 'Closing stock (By sale price):',       value: '$ 3,446,924.53' },
                        { label: 'Total Sales: (Exc. tax, Discount)',    value: '$ 1,000.32',  hi: true },
                        { label: 'Total sell shipping charge:',          value: '$ 630.00' },
                        { label: 'Sell additional expenses:',            value: '$ 0.00',   hi: true },
                        { label: 'Total Stock Recovered:',               value: '$ 0.00' },
                        { label: 'Total Purchase Return:',               value: '$ 436.99', hi: true },
                        { label: 'Total Purchase discount:',             value: '$ 0.00' },
                        { label: 'Total sell round off:',                value: '$ -0.33', hi: true },
                    ].map((row, i) => (
                        <div key={i} style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            padding: '0.5rem 0.5rem',
                            background: row.hi ? '#f8fafc' : 'transparent',
                            borderBottom: '1px solid #f1f5f9',
                        }}>
                            <span style={{ fontSize: '0.8125rem', color: '#334155', fontWeight: '500' }}>{row.label}</span>
                            <span style={{ fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600' }}>{row.value}</span>
                        </div>
                    ))}
                </div>
            </div>

            {/* ── Profit Summary Card ── */}
            <div style={{
                background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px',
                padding: '1.25rem 1.5rem', marginBottom: '1rem',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            }}>
                <div style={{ marginBottom: '0.75rem' }}>
                    <span style={{ fontSize: '1rem', color: '#64748b' }}>
                        Gross Profit: <strong style={{ color: '#1e293b' }}>$ 8,365.16</strong>
                    </span>
                    <div style={{ fontSize: '0.75rem', color: '#94a3b8', marginTop: '0.2rem' }}>
                        (Total sell price - Total purchase price) + Project Invoice
                    </div>
                </div>
                <div>
                    <span style={{ fontSize: '1rem', color: '#64748b' }}>
                        Net Profit: <strong style={{ color: '#1e293b' }}>$ 8,044.83</strong>
                    </span>
                    <div style={{ fontSize: '0.75rem', color: '#94a3b8', marginTop: '0.2rem', lineHeight: 1.5 }}>
                        Gross Profit + (Total sell shipping charge + Sell additional expenses + Total Stock Recovered + Total Purchase discount + Total sell round off)<br />
                        - (Total Stock Adjustment + Total Expense + Total purchase shipping charge + Total transfer shipping charge + Purchase additional expenses + Total Sell discount + Total customer reward + Total Payroll + Total Production Cost)
                    </div>
                </div>
            </div>

            {/* ── Sub-tabs ── */}
            <div style={{ display: 'flex', gap: 0, borderBottom: '1px solid #e2e8f0', marginBottom: '1rem', flexWrap: 'wrap' }}>
                {subTabs.map(tab => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveSubTab(tab.id)}
                        style={{
                            padding: '0.75rem 1rem',
                            background: 'none',
                            border: 'none',
                            borderBottom: activeSubTab === tab.id ? '2px solid #3b82f6' : '2px solid transparent',
                            color: activeSubTab === tab.id ? '#3b82f6' : '#64748b',
                            fontWeight: activeSubTab === tab.id ? '600' : '500',
                            fontSize: '0.875rem',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                        }}
                    >
                        <i className={`fa ${tab.icon}`} />
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* ── Table Card ── */}
            <div style={{
                background: '#fff', border: '1px solid #e2e8f0', borderRadius: '10px',
                overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            }}>
                {/* Table controls */}
                <div className="table-controls" style={{ borderBottom: '1px solid #e2e8f0', padding: '0.75rem 1.25rem' }}>
                    <div className="table-controls-left">
                        <div className="entries-select">
                            <span>Show</span>
                            <select value={entriesPerPage} onChange={e => setEntriesPerPage(Number(e.target.value))}>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </select>
                            <span>entries</span>
                        </div>
                    </div>

                    <div className="table-controls-right">
                        {/* Export dropdown */}
                        <div className="export-dropdown-container" style={{ position: 'relative' }}>
                            <button
                                className="export-btn"
                                onClick={() => setShowExportDropdown(!showExportDropdown)}
                                style={{
                                    display: 'flex', alignItems: 'center', gap: '0.4rem',
                                    padding: '0.4rem 0.8rem', border: '1px solid #e2e8f0',
                                    borderRadius: '6px', background: '#fff', cursor: 'pointer',
                                    fontSize: '0.85rem', color: '#334155',
                                }}
                            >
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="7 10 12 15 17 10" />
                                    <line x1="12" y1="15" x2="12" y2="3" />
                                </svg>
                                Export ▾
                            </button>
                            {showExportDropdown && (
                                <div className="export-dropdown-menu" style={{
                                    position: 'absolute', top: '100%', right: 0, marginTop: '0.25rem',
                                    background: '#fff', border: '1px solid #e2e8f0', borderRadius: '6px',
                                    boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', zIndex: 10, minWidth: '160px',
                                }}>
                                    {exportItems.map((item, i) => (
                                        <button
                                            key={i}
                                            onClick={() => { if (item.action) item.action(); setShowExportDropdown(false); }}
                                            style={{
                                                display: 'flex', alignItems: 'center', gap: '0.5rem',
                                                width: '100%', padding: '0.5rem 1rem', border: 'none',
                                                background: 'none', textAlign: 'left', cursor: 'pointer',
                                                fontSize: '0.8125rem', color: '#475569',
                                            }}
                                            onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f1f5f9'}
                                            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                        >
                                            <i className={`fa ${item.icon}`} style={{ width: '14px', textAlign: 'center' }} />
                                            {item.label}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Search */}
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            style={{
                                padding: '0.4rem 0.75rem',
                                border: '1px solid #e2e8f0',
                                borderRadius: '6px',
                                fontSize: '0.8125rem',
                                outline: 'none',
                                width: '180px',
                            }}
                        />
                    </div>
                </div>

                {/* Table */}
                <div style={{ overflowX: 'auto' }}>
                    <table className="products-table" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                        <thead>
                            <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600' }}>
                                    Product <i className="fa fa-sort" style={{ color: '#cbd5e1', marginLeft: '4px' }} />
                                </th>
                                <th style={{ padding: '0.75rem 1rem', fontSize: '0.8125rem', color: '#1e293b', fontWeight: '600', textAlign: 'right' }}>
                                    Gross Profit <i className="fa fa-arrows-v" style={{ color: '#cbd5e1', marginLeft: '4px' }} />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan="2" style={{ textAlign: 'center', padding: '2.5rem', color: '#94a3b8', fontSize: '0.9rem' }}>
                                    No data available in table
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="pagination" style={{ padding: '0.85rem 1.25rem', borderTop: '1px solid #e2e8f0' }}>
                    <div className="pagination-info" style={{ fontSize: '0.8125rem' }}>
                        Showing 0 to 0 of 0 entries
                    </div>
                    <div className="pagination-controls">
                        <button className="page-btn disabled">Previous</button>
                        <button className="page-btn active">1</button>
                        <button className="page-btn disabled">Next</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfitLossReport;
